import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomPhoneInput from "./PhoneInput";

const CustomerForm = ({ isOpen, onClose ,fetchContacts , user }) => {
  const modalRef = useRef(null);
  const [newCustomer, setNewCustomer] = useState({ name: "", MobileNumber: "", location: "", email: "" });

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Handle form input change
  const handleChange = (e) => {
    setNewCustomer({ ...newCustomer, [e.target.name]: e.target.value });
  };

  // Handle adding a new customer
  const handleAddCustomer = async () => {
    if (!newCustomer.name || !newCustomer.MobileNumber || !newCustomer.location || !newCustomer.email) {
      toast.error("Please fill all fields!");
      return;
    }
  
    if (!user || !user.id) {
      toast.error("User not logged in!");
      return;
    }


  try {

// Check if MobileNumber is in DND list
      const dndCheckResponse = await axios.get(
        `${process.env.REACT_APP_SERVER_API}/api/dnd-list?userId=${user.id}&role=${user.role}`
      );
      const dndList = dndCheckResponse.data;
      const isInDnd = dndList.some((entry) => entry.to === newCustomer.MobileNumber);

      if (isInDnd) {
        toast.error("This contact is already in the DND list");
        return;
      }

    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_API}/api/contacts`,
      {
        ...newCustomer,
        userId: user.id, // Include userId from logged-in user
      }
    );
    toast.success("Customer added successfully!");

    setTimeout(() => {
      setNewCustomer({ name: "", MobileNumber: "", location: "", email: "" });
      fetchContacts(); 
      onClose();
    }, 2000);
  } catch (error) {
    toast.error("Failed to add customer.");
    console.error(error);
  }
};
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div ref={modalRef} className="bg-white p-6 rounded-lg shadow-lg w-[550px]">
        <h2 className="text-2xl font-semibold mb-4">Add New Customer</h2>

        <input type="text" name="name" placeholder="Name" className="border p-2 w-full mb-3 rounded" value={newCustomer.name} onChange={handleChange} />
        {/* <input type="text" name="MobileNumber" placeholder="Mobile Number" className="border p-2 w-full mb-3 rounded" value={newCustomer.MobileNumber} onChange={handleChange} /> */}



     <CustomPhoneInput value={newCustomer.MobileNumber} 
          onChange={(value) => setNewCustomer({ ...newCustomer, MobileNumber: value })} ></CustomPhoneInput>

        <input type="text" name="location" placeholder="Location" className="border p-2 w-full mb-3 rounded mt-3" value={newCustomer.location} onChange={handleChange} />
        <input type="email" name="email" placeholder="Email" className="border p-2 w-full mb-3 rounded" value={newCustomer.email} onChange={handleChange} />

        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="bg-gray-500 px-4 py-2 rounded text-white">Cancel</button>
          <button onClick={handleAddCustomer} className="bg-blue-600 px-4 py-2 rounded text-white">Add</button>
        </div>

        <ToastContainer />
      </div>
    </div>
  );
};

export default CustomerForm;
